import React, { useCallback, useState } from "react";
import style from "./Invoice.module.css";
import { Box } from "@mui/system";
import CommonButton from "../../CommonComponents/CommonButton";
import DownloadIcon from "../../Images/Svg/DownloadIcon.svg";
import FilterPopOver from "../CaseManagement/CaseManagementFilter/FilterPopOver";
import {
  filterStatusReducer,
  invoiceDateReducer,
} from "../../Redux/Slice/FilterSlice";
import { useDispatch } from "react-redux";
import useToaster from "../../customHook/useToaster";
import TableComponent from "../../CommonComponents/Table";
import { ApprovalTableData } from "../../constants/approvalsData";
import UploadedInvoices from "./UploadedInvoices";
import { useNavigate } from "react-router";
import { inoviceTableData } from "../../constants/invoiceTableData";

let buttonStyle = {
  fontSize: "2.8rem",
  paddingTop: "0.4rem",
  paddingBottom: "0.4rem",
};

const Invoices = () => {
  const [isDateFilterClicked, setisDateFilterClicked] = useState(false);
  const [isStatusFilterClicked, setisStatusFilterClicked] = useState(false);
  const [isDateIconClicked, setisDateIconClicked] = useState(false);
  const [isStatusIconClicked, setisStatusIconClicked] = useState(false);
  const [isStatusItemClicked, setisStatusItemClicked] = useState(false);
  const [filterSearchData, setFilterSearchData] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [isUploadedInvoice, setIsUploadedInvoice] = useState(false);
  const [activeCaseId, setActiveCaseId] = useState("");
  const { showToast } = useToaster();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dateFilterHandler = () => {
    setisDateFilterClicked(!isDateFilterClicked);
    setisDateIconClicked(!isDateIconClicked);
  };
  const statusFilterHandler = () => {
    setisStatusIconClicked(!isStatusIconClicked);
    setisStatusFilterClicked(!isStatusFilterClicked);
  };
  const statusItemHandler = (option) => {
    setisStatusItemClicked(true);
  };
  const startDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`;
    dispatch(invoiceDateReducer({ approvalStartDate: value }));
  };
  const endDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}  -${d.getDate()}-${d.getFullYear()}`;
    dispatch(invoiceDateReducer({ approvalEndDate: value }));
  };
  const handleFilterByTag = (e) => {
    if (e.keyCode === 13) {
      setFilterSearchData(e.target.value);
    }
  };
  const handleClick = (event) => {
    return showToast("Coming soon", "info", true);
    setAnchorEl(event.currentTarget);
  };
  const handleFilterApply = (e) => {
    setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleFilterReset = () => {
    setFilterSearchData("");
    dispatch(
      invoiceDateReducer({ approvalStartDate: "", approvalEndDate: "" })
    );
    dispatch(filterStatusReducer(""));
  };

  const onClickFirstPopper = useCallback(() => {
    // navigate("/uploadedInvoice");
  }, []);

  const onCellClicked = useCallback((e, colid, colValue, lobName, index) => {
    // setIsUploadedInvoice(true);
    setActiveCaseId(colValue);
  }, []);

  return isUploadedInvoice ? (
    <UploadedInvoices
      backHandler={() => setIsUploadedInvoice(false)}
      caseId={activeCaseId}
    />
  ) : (
    <Box sx={{ marginTop: "2.5rem", marginLeft: "2.5rem" }}>
      <div className={style["invoice_heading"]}>
        <h2 className={style["invoice_text"]}>Invoice</h2>
        <div className={style["filter-download_btn"]}>
          <div style={{ width: "max-content" }}>
            <FilterPopOver
              isDateFilterClicked={isDateFilterClicked}
              isStatusFilterClicked={isStatusFilterClicked}
              isDateIconClicked={isDateIconClicked}
              isStatusIconClicked={isStatusIconClicked}
              isStatusItemClicked={isStatusItemClicked}
              anchorEl={anchorEl}
              dateFilterHandler={dateFilterHandler}
              statusFilterHandler={statusFilterHandler}
              statusItemHandler={statusItemHandler}
              startDateHandler={startDateHandler}
              endDateHandler={endDateHandler}
              handleFilterByTag={handleFilterByTag}
              handleClick={handleClick}
              handleClose={handleClose}
              handleFilterApply={handleFilterApply}
              handleFilterReset={handleFilterReset}
            />
          </div>
          <div style={{ width: "max-content" }}>
            <CommonButton
              label=""
              isIcon={true}
              iconName={
                <img
                  src={DownloadIcon}
                  alt="Download Icon"
                  style={buttonStyle}
                />
              }
              backgroundColor={"#ffffff"}
              textColor={"#E42125"}
              removeBorder={true}
              smallButton={true}
              filledButton={false}
              removeBackGround={true}
              onClick={() => showToast("Coming soon", "info", true)}
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: "15px" }}>
        <TableComponent
          stickyHeader={false}
          columnHeaderBackgroundColor={"#FCF7FF"}
          columnHeaderColor={"#242424"}
          columnHeaderFontWeight={600}
          columnBodyFontWeight={400}
          rowsData={inoviceTableData[0].row}
          columnsData={inoviceTableData[0].column}
          hideBorders={true}
          alternnateStyledRow={true}
          alternnateStyledRowColor={"#FBF5FF"}
          onClickFirstPopper={onClickFirstPopper}
          onCellClicked={onCellClicked}
          setIsUploadedInvoice={setIsUploadedInvoice}
        />
      </div>
    </Box>
  );
};

export default Invoices;
